import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import StampDutyCalculator from "../../calculators/StampDutyCalculator";

const StampDutyPage = () => {
  return (
    <div>
      <Hero
        title="Stamp Duty"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <StampDutyCalculator/>
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default StampDutyPage;
